// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disabled-font-style[data-v-b84c625e] {\n  color: #8794B5;\n  opacity: .30;\n}\n.border-right-only[data-v-b84c625e] {\n  border-right-width: 1px;\n  border-right-style: solid;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
